export const PublishTypes = {
  publish: 'publish',
  update: 'update',
  schedule: 'schedule'
};